import {
  sellTokenAtom,
  sellTokenAmountAtom,
} from 'src/pages/TradePage/stores/trade-store'
import { useAtomValue } from 'jotai'
import useApprovalStatus from 'src/common/contracts/hooks/token/useApprovalStatus'
import useGasEstimate from 'src/common/contracts/hooks/useGasEstimate'
import useLimitOrderTx from './useLimitOrderTx'
import useConfig from 'src/config/hooks/useConfig'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'

const useLimitOrder = () => {
  const sellToken = useAtomValue(sellTokenAtom)
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)
  const config = useConfig()
  const { smartAccountInfo } = useSmartAccount()

  // Approval and allowance check
  const {
    approveTokenTx,
    needsApproval,
    refetchAllowance,
    loading: allowanceLoading,
  } = useApprovalStatus({
    owner: smartAccountInfo?.address,
    token: sellToken,
    amountToSpend: sellTokenAmount,
    spender: config.contractsAddresses.dotcContractAddress,
  })

  // Offer transaction preparation
  const { makeOfferTx, priceFeedsLoading } = useLimitOrderTx()
  const transaction = makeOfferTx()

  // Gas estimation
  const { gasEstimateInEther, estimateGas } = useGasEstimate({ transaction: transaction })

  return {
    makeOfferTx,
    approveTokenTx,
    needsApproval,
    gasEstimateInEther,
    refetchGasEstimate: estimateGas,
    refetchAllowance,
    loading: allowanceLoading || priceFeedsLoading,
  }
}

export default useLimitOrder
